/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".revenue-date[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:16px;height:100%;justify-content:flex-start;align-items:center}.revenue-date__header[_ngcontent-%COMP%]{font-weight:600;margin:64px auto 32px}.revenue-date__body[_ngcontent-%COMP%]{max-width:320px}.revenue-date__body__text[_ngcontent-%COMP%]{color:var(--color-text);font-size:18px;font-weight:600;margin:0 0 8px}.revenue-date__body__button[_ngcontent-%COMP%]{margin-top:32px;width:100%}"];
export { styles as styles };
